/* This file was automatically generated - please modify the template not this file! */

import { Dispatch } from "redux";

import { isRequestActive, loadAndTrack } from "redux-request-loading";

import { Payload } from "@neworbit/redux-helpers";

import { loadEmployeeRecordsSuccess } from "../employeeRecord/actions";
import { CustomerTeamAction } from "../customerTeam/actions";
import { ApplicationState } from "../../applicationState";

import * as actions from "./actiontypes";
import * as models from "./model";
import { customerApi } from "./customerApi";

import { push } from "redux-little-router";

export type CustomerAction =
      ({ type: typeof actions.LOAD_CUSTOMERS_SUCCESS } & Payload<models.CustomerListModel[]>)
    | ({ type: typeof actions.CREATE_CUSTOMER_SUCCESS } & Payload<models.CustomerDetailModel>)
    | ({ type: typeof actions.LOAD_CUSTOMER_DETAIL_SUCCESS } & Payload<models.CustomerDetailModel>)
    | ({ type: typeof actions.SAVE_CUSTOMER_SUCCESS } & Payload<models.CustomerDetailModel>)
    | ({ type: typeof actions.ACTIVATE_CUSTOMER_SUCCESS } & Payload<any>)
    | ({ type: typeof actions.DEACTIVATE_CUSTOMER_SUCCESS } & Payload<any>)
    | ({ type: typeof actions.DELETE_CUSTOMER_SUCCESS } & Payload<any>)
    | CustomerTeamAction;

export const deactivateCustomerSuccess = (payload: models.CustomerDetailModel): CustomerAction => ({
    payload,
    type: actions.DEACTIVATE_CUSTOMER_SUCCESS
});

export const activateCustomerSuccess = (payload: models.CustomerDetailModel): CustomerAction => ({
    payload,
    type: actions.ACTIVATE_CUSTOMER_SUCCESS
});
export const loadCustomersSuccess = (payload: models.CustomerListModel[]): CustomerAction => ({
    payload,
    type: actions.LOAD_CUSTOMERS_SUCCESS
});

export const createCustomerSuccess = (payload: models.CustomerDetailModel): CustomerAction => ({
    payload,
    type: actions.CREATE_CUSTOMER_SUCCESS
});

export const saveCustomerSuccess = (payload: models.CustomerDetailModel): CustomerAction => ({
    payload,
    type: actions.SAVE_CUSTOMER_SUCCESS
});

export const deleteCustomerSuccess = (id: any): CustomerAction => ({
    payload: id,
    type: actions.DELETE_CUSTOMER_SUCCESS
});

export function deactivateCustomer(id: any) {
    return async (dispatch: Dispatch) => {
        await loadAndTrack(dispatch, "deactivateCustomer", customerApi.deactivate(id));
        dispatch(deactivateCustomerSuccess(id));
    };
}

export function activateCustomer(id: any) {
    return async (dispatch: Dispatch) => {
        await loadAndTrack(dispatch, "activateCustomer", customerApi.activate(id));
        dispatch(activateCustomerSuccess(id));
    };
}

export function createCustomer(customer: models.CustomerCreateModel, path: string) {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, actions.CREATE_CUSTOMER, customerApi.create(customer));
        dispatch(createCustomerSuccess(result));
        dispatch(push(`${path}/${result.id}`, {}));
    };
}

export function saveCustomer(customer: models.CustomerEditModel, path?: string) {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, actions.SAVE_CUSTOMER, customerApi.save(customer));

        dispatch(saveCustomerSuccess(result));
        if (path !== undefined) {
            dispatch(push(`${path}/${result.id}`, {}));
        }
    };
}

export function deleteCustomer(id: any, path: string) {
    return async (dispatch: Dispatch) => {
        await loadAndTrack(dispatch, "deleteCustomer", customerApi.delete(id));
        dispatch(deleteCustomerSuccess(id));
        dispatch(push(`${path}`, {}));
    };
}

export function loadCustomers() {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, actions.LOAD_CUSTOMERS, customerApi.getAll());
        dispatch(loadCustomersSuccess(result));
    };
}

export function loadCustomerEmployeeRecords({ customerId, firstName, lastName, personalReferenceNumber, dateOfBirth, secondaryReference }:
    { customerId: string; firstName: string; lastName: string; personalReferenceNumber: string; dateOfBirth: string; secondaryReference: string }) {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(
            dispatch, "loadCustomerEmployeeRecords",
            customerApi.employeeRecords({ customerId, firstName, lastName, personalReferenceNumber, dateOfBirth, secondaryReference })
        );
        dispatch(loadEmployeeRecordsSuccess(result));
    };
}

export const loadCustomerDetailSuccess = (customer: models.CustomerDetailModel) => ({
    payload: customer,
    type: actions.LOAD_CUSTOMER_DETAIL_SUCCESS
});

export function loadCustomerDetail({ customerId }: { customerId: string }) {
    return async (dispatch: Dispatch, getState: () => ApplicationState) => {
        const state = getState();
        const customer = state.customers.filter(c => c.id === customerId)[0];
        const requestName = `${actions.LOAD_CUSTOMER_DETAIL}_${customerId}`;

        if (isRequestActive(state, requestName) !== true
            && (customer === undefined
            || (customer as models.CustomerDetailModelInRedux).detailUpdated === undefined
            || (customer as models.CustomerDetailModelInRedux).detailUpdated.isBefore((customer as models.CustomerDetailModelInRedux).listUpdated))) {
            const result = await loadAndTrack(dispatch, requestName, customerApi.detail(customerId));
            dispatch(loadCustomerDetailSuccess(result));
        }
    };
}
